module.exports = __webpack_public_path__ + "img/2.1aa5919.png";